import MachinesGroups from "components/myMachines/MachinesGroups";
import { useUserContext } from "context/userContext";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function UserMachines() {
  const navigate = useNavigate();
  const {isAuth} = useUserContext()

  useEffect(() => {
    if(!isAuth){
        navigate('/')
    }
})

  return <MachinesGroups />;
}

export default UserMachines;
